import { SEARCH_DEPARTURE_PORTS } from 'constants/cruise'
import { popularDestinations } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalCruisesSearch'

const sortByMapping = {
  'Price (Lowest)': 'price.dsc',
  'Price (Highest)': 'price.asc',
  Newest: 'updated_at.desc',
  'Depart soon': 'departure_date.asc',
}

const durationMapping: Record<string, { durationMin: number | undefined, durationMax: number| undefined }> = {
  'Any duration': { durationMin: undefined, durationMax: undefined },
  'Short trip': { durationMin: 1, durationMax: 7 },
  'Medium trip': { durationMin: 8, durationMax: 14 },
  'Long trip': { durationMin: 15, durationMax: undefined },
}

function filterCruiseContent(
  section: { [key: string]: any },
) {
  const filter: App.OfferListFilters = {}
  Object.entries(section).map(([key, val]) => {
    switch (key) {
      case 'rateCodes':
      case 'cruiseShips':
      case 'cabinTypes':
      case 'minPrice':
      case 'maxPrice':
      case 'campaigns':
        filter[key] = val
        break
      case 'vendor':
        filter.cruiseLines = val
        break
      case 'sortBy':
        filter.sortBy = sortByMapping[val as keyof typeof sortByMapping] as App.OfferListSortByOptions
        break
      case 'duration':
        filter.durationMin = durationMapping[val as keyof typeof durationMapping].durationMin
        filter.durationMax = durationMapping[val as keyof typeof durationMapping].durationMax
        break
      case 'destinationPlace':
        const destination = popularDestinations.filter(destination => destination.format.mainText === val)
        filter.destinationId = destination[0]?.value
        break
      case 'departurePlace':
        const departure = SEARCH_DEPARTURE_PORTS.filter(port => port.format.mainText === val)
        filter.departurePlaceId = departure[0]?.value
        break
    }
  })

  if (section?.filters?.campaigns) {
    filter.campaigns = section.filters.campaigns
  }

  return filter
}

export default filterCruiseContent
